import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { isEmptyObject } from 'jquery';
import ReactNotification, {store} from 'react-notifications-component';
import Services from '../../services/service';
import moment from 'moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import { MODALACTION, RESPONSE } from '../../config/constants';

const { CREATE, EDIT, DELETE, DOWNLOAD } = MODALACTION;
const { SUCCESS, FAILED, INVALID } = RESPONSE;
const qrImgStyle = {
  width: '200px',
  height: '200px'
};

class AssetManagement extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      name: '',
      year: '',
      category: '',
      serialNumber: '',
      actionModal: '',
      selectedItem: {},
      dataAsset: [],
      categoryList: [],
      assetQr: '',
      status: '',
      uriParams: '',
    };
    this.initialState = this.state;
  }

  componentDidMount(){
    this.getDataAsset();
    this.setState({uriParams: window.location.pathname.split('/')[3]?.replace('+', ' ') ?? ''});
  }

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
    store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true }
    });
  }

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'All your data has been successfully updated', 'top-right');
        break;
      case FAILED:
        this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
        break;
      case INVALID:
        this.addNotification('danger', 'Invalid Format', 'This field should be 4 digits numeric', 'top-right');
        break;
      default:
        break;
    }
  };

  getDataAsset = () => {
    Services.getAsset()
      .then(res => {
        this.setState({dataAsset: res});
        this.getCategoryList();
      })
      .catch(err => console.log(err))
  };

  getCategoryList = () => {
    Services.getList({param: 'assetstype'})
      .then(res => {
        this.setState({categoryList: res});
      })
      .catch(err => console.log(err))
  };

  handleDeleteData = () => {
    const { selectedItem } = this.state;
    const payload = selectedItem._id;
    Services.deleteAsset(payload)
      .then(res => {
        this.setState({modalAdd: false});
        this.toggleNotification(SUCCESS);
        this.getDataAsset();
      })
      .catch(err => {
        console.log(err);
        this.setState({modalAdd: false});
        this.toggleNotification(FAILED);
      });
  };

  handleUpdateData = () => {
    const { selectedItem, name, serialNumber, category, year, status } = this.state;
    const param = { params: { assetId: selectedItem._id }};
    const payload = {
      name: name ? name : selectedItem.name,
      serialNumber: serialNumber ? serialNumber : selectedItem.serialNumber,
      category: category ? category : selectedItem.category,
      year: year ? year : selectedItem.year,
      status
    };

    Services.updateAsset(payload, param)
      .then(res => {
        this.setState(this.initialState);
        this.toggleNotification(SUCCESS);
        this.getDataAsset();
      })
      .catch(err => {
        console.log(err);
        this.setState({ modalAdd: false });
        this.toggleNotification(FAILED);
      });
  };

  handleSubmitData = () => {
    const { name, serialNumber, category, year, status } = this.state;
    const payload = {
      name,
      serialNumber,
      category,
      year,
      status
    };

    Services.postAsset(payload)
      .then(res => {
        this.setState(this.initialState);
        this.toggleNotification(SUCCESS);
        this.getDataAsset();
      })
      .catch(err => {
        console.log(err);
        this.setState({ modalAdd: false });
        this.toggleNotification(FAILED);
      });
  };

  handleFieldChange = (key) => (e) => {
    const re = /^[0-9\b]+$/;
    if(key === "year") {
      if (e.target.value === "" || re.test(e.target.value)) {
        const state = { [key]: e.target.value };
        this.setState(state);
      } else {
        this.toggleNotification(INVALID)
      }
    } else {
      const state = { [key]: e.target.value };
      this.setState(state);
    }
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Aset</li>
      </ol>
      <h1 className="page-header">Aset</h1>
    </div>
  );

  renderTableAsset = () => {
    const { dataAsset, uriParams } = this.state;
    const filterParams = uriParams === '' ? null : uriParams;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "serialNumber",
        label: "Serial Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "categoryName",
        label: "Category",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "year",
        label: "Year",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          ...(filterParams !== null && {filterList: [filterParams]}),
          filter: true,
          sort: true,
        }
      },
      {
        name: "createDate",
        label: "Date Created",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      // {
      //   name: "updateDate",
      //   label: "Date Updated",
      //   options: {
      //     filter: true,
      //     sort: true,
      //   }
      // },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                <Link
                  to={{
                    pathname: '/master/detail-asset',
                    state: {
                      selectedData: dataAsset[tableMeta.rowIndex]
                    }
                  }}
                >
                <button
                  className="btn btn-sm btn-success width-70 m-r-2">
                    DETAIL
                </button>
                </Link>
                <button
                  className="btn btn-sm btn-primary m-r-2"
                  onClick={() => this.toggleDownload(dataAsset[tableMeta.rowIndex])}
                >{DOWNLOAD}</button>
                <button
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => this.onClickEditAsset(EDIT, dataAsset[tableMeta.rowIndex])}
                >{EDIT}</button>
                <button
                  onClick={() =>
                    this.toggleAddModal(DELETE, dataAsset[tableMeta.rowIndex])
                  }
                  className="btn btn-sm btn-danger width-70 m-r-2">{DELETE}</button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
      customToolbar: () => (
        <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
      ),
    };

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Aset"}
          data={dataAsset}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    )
  };

  //Start Modal Method

  toggleAddModal = (action = '', item = {}) => {
    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: item
    });
  };

  onClickEditAsset = (method, data) => {
    this.toggleAddModal(method, data);
    const payload = {
      type : 'assets-data',
      id: data._id
    };
    Services.postAssetQr(payload)
      .then(res => {
        this.setState({ assetQr: res.file, name: data.name });
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  toggleDownload = (item) => {
    const payload = {
      type : 'assets-data',
      id: item._id
    };
    Services.postAssetQr(payload)
      .then(res => {
        this.setState({ assetQr: res.file, name: item.name });
        const link = document.createElement('a');
        link.href = res.file;
        link.setAttribute('download', this.state.name + ' QR.jpeg'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  handleStatus = e => {
    this.setState({ status: e.target.value });
  };

  renderAddAssetModal = () => {
    const { actionModal, selectedItem, name, serialNumber, category, year } = this.state;
    const formData = [name, category];
    const disabled = formData.includes('');
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    let categoryOptions = this.state.categoryList.length > 0
      && this.state.categoryList.map((item, i) => {
        return (
          <option key={i} value={item.id}>{item.name}</option>
        )
      }, this);
    return (
      <Modal isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Name</label>
            <input
              onChange={this.handleFieldChange('name')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.name : name}
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Nomor</label>
            <input
              onChange={this.handleFieldChange('serialNumber')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem.serialNumber : serialNumber }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <select
              onChange={this.handleFieldChange('category')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.category : category }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {categoryOptions}
            </select>
          </div>
          <div className="form-group">
            <label>Year</label>
            <input
              maxLength={4}
              onChange={this.handleFieldChange('year')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem.year : year }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <div className="container">
              <div style={{margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                <input type="radio" id="active" name="assetStatus" value="Active" defaultChecked={selectedItem.status === 'Active'} onChange={this.handleStatus}/>
                <label style={{marginLeft: "2px"}} htmlFor={"active"}>Active</label>
              </div>
              <div style={{margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                <input type="radio" id="notActive" name="assetStatus" value="Not Active" defaultChecked={selectedItem.status === 'Not Active'} onChange={this.handleStatus}/>
                <label style={{marginLeft: "2px"}} htmlFor={"notActive"}>Not Active</label>
              </div>
              <div style={{margin: "12px", display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
                <input type="radio" id="repair" name="assetStatus" value="Repair" defaultChecked={selectedItem.status === 'Repair'} onChange={this.handleStatus}/>
                <label style={{marginLeft: "2px"}} htmlFor={"repair"}>Repair</label>
              </div>
            </div>
          </div>
          {actionModal === EDIT &&
            <div className="form-group" style={{ textAlign: 'center' }}>
              <img src={`data:${this.state.assetQr}`} alt="QR code" style={qrImgStyle}/>
              <div style={{marginTop: 20, textAlign: 'center'}}>
                <a download={this.state.name + " QR.jpg"} href={`data:${this.state.assetQr}`}>
                  <button type="button" className="btn btn-success">Download</button>
                </a>
              </div>
            </div>
          }
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={actionModal===CREATE && disabled}
            onClick={()=> this.setActionButton(actionModal)}
          >
            {actionModal}
          </button>
        </ModalFooter>
      </Modal>
    )
  }

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Asset';
      case EDIT :
        return 'Edit Asset';
      case DELETE :
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  };

  setActionButton = (value) => {
    switch (value) {
      case CREATE :
        this.handleSubmitData();
        break;
      case EDIT :
        this.handleUpdateData();
        break;
      case DELETE :
        this.handleDeleteData();
        break;
      default:
        break;
    }
  };

  //End Modal Method

  render() {
    return (
      <div>
        <ReactNotification/>
        {this.renderBreadcrumb()}
        <div>
          {this.renderTableAsset()}
        </div>
        {this.renderAddAssetModal()}
      </div>
    )
  }
}

export default AssetManagement;
